import { useContext } from 'react';
import { RoutesContext } from '../context/RoutesContext';
import { Routes } from '../types';

export const useAppRoutes: () => Routes = () => {
  return useContext(RoutesContext);
};
